import { ORIGIN_SYSTEM } from '@/utils/constants';
import axios from 'axios';

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },
  getHeaders() {
    return {
      Authorization: `Bearer ${this.getToken()}`,
      'origin-system': ORIGIN_SYSTEM.BPSEG,
    };
  },
  async createQuotation(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/quotations`,
        payload,
        {
          headers: this.getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async createEndorsementQuotation(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/endorsement/quotations`,
        payload,
        {
          headers: this.getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async recalculateEndorsement(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/endorsement/quotations/calculate`,
        payload,
        {
          headers: this.getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getNegativeEndorsementInstallments(policyId) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/endorsement/policies/${policyId}/negative-endorsement-installments`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getCpfData(cpf) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/customers/${cpf}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getQuotation(id, inspecton = false) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/quotations/${id}`,
        {
          params: {
            inspection: inspecton,
          },
          headers: this.getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getOpenEndorsementQuotationByPolicyNumber(policyNumber) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/endorsement/quotations/open`,
        {
          params: {
            activatedPolicyNumber: policyNumber,
          },
          headers: this.getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getQuotationStatus(id) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/quotations/${id}/status`,
        {
          headers: this.getHeaders(),
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getBrokers() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/brokers`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getBrokersList() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/brokers?scope=all`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getAccessibleBrokers() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/brokers?scope=user`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getConsultanciesList() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/consultancies?scope=all`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getAccessibleConsultancies() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/consultancies?scope=user`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCovenantsList() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/covenants?scope=all`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getAccessibleCovenants() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/covenants?scope=user`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getUsersList() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/users`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getAccessibleUsers() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/users?scope=user`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getDueDays() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/due-days`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getPaymentMethods() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-methods`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async update(id, payload) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/quotations/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async recalculate(id, payload, validate = false) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/quotations/${id}/recalculate?validate=${validate}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async updateProposalContactInfo(id, payload) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/proposals/${id}/contact-info`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async transmitProposal(id, payload) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/proposals/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getBalance(brokerId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/admin/broker-accounts/balance/${brokerId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getBrokerAccountConfigs() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/admin/broker-accounts/configs`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCharges() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/life/charges`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getVehicleByPlate(plate) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicles/${plate}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getVehicleByChassi(chassi) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicles/chassis/${chassi}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getIncreases(zipCode) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/increases`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            zip_code: zipCode,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCoverages(
    chassis,
    typeId,
    brandId,
    modelId,
    yearManufacture,
    state,
    city,
    coverageValue,
  ) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/coverages`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            chassis: chassis,
            typeId: typeId,
            brandId: brandId,
            modelId: modelId,
            yearManufacture: yearManufacture,
            state: state,
            city: city,
            coverageValue: coverageValue,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getVehicleTypes() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-types`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getVehicleBrands(vehicleTypeId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-types/${vehicleTypeId}/brands`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getVehicleModels(vehicleTypeId, brandId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-types/${vehicleTypeId}/brands/${brandId}/models`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getVehicleModelsByYear(vehicleTypeId, brandId, year) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-types/${vehicleTypeId}/brands/${brandId}/model-years/${year}/models`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getVehicleYears(vehicleTypeId, brandId, modelId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-types/${vehicleTypeId}/brands/${brandId}/models/${modelId}/years`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getFipe(vehicleTypeId, brandId, modelId, yearId, fuelId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-types/${vehicleTypeId}/brands/${brandId}/models/${modelId}/years/${yearId}/fuels/${fuelId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getFipeByCode(vehicleTypeId, yearId, fuelId, fipeCode) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-types/${vehicleTypeId}/years/${yearId}/fuels/${fuelId}/fipe/${fipeCode}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async activatePolicy(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/policies/activate`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async issueEndorsement(payload, policyId) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/endorsement/issuance/policy/${policyId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getQuotationConfigs() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/configs`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCompanyRules() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/company-rules`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async updateCompanyRules(payload) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/company-rules`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCompanyRulesHistory() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/company-rules/history`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getCongeners() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners?raw=true`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCongenersLabeled(susepCode) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            selected_susep_code: susepCode,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getBrokerCommissionReport(brokerId, startDate, endDate) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/admin/reports/broker-commission`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            brokerId: brokerId,
            startDate: startDate,
            endDate: endDate,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async saveConsultancy(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/consultancies`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getMonthDistribuitionInfo() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/admin/broker-accounts/monthDistribuitionInfo`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getProductsContracted(policyId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/policy/${policyId}/products-contracted`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCiValidation(ciCode) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/bonus/ci-validation/${ciCode}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
